import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import { ButtonLoader } from 'components/__new/common/form';
import FormDrawer from 'components/__new/common/form-drawer'
import * as approvalAction from "store/entities/approvals/action"
import * as notificationAction from "store/entities/notification/action";

const DisableWorkflow = ({isOpen, setIsOpen, workflow, getWorkflows}) => {
    const dispatch = useDispatch();
    const {disabledWorkflowLoading, disabledWorkflow} = useSelector(s => s.entities.approvals)

    const disableWorkflow = () => {
        const payload = {
            status: 'disabled'
        }
        const workflowId = workflow?.id;
        dispatch(approvalAction.disableWorkflow(payload, workflowId));
    }

    useEffect(() => {
        if (disabledWorkflow?.error === false) {
            getWorkflows();
            setIsOpen(false)
            toast.success("Workflow successfully disabled");
            dispatch(approvalAction.resetDisabledWorkflow());
            dispatch(notificationAction.getAllNotifications());
        }
    }, [disabledWorkflow, dispatch])

    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                
                <FormDrawer.Title
                    title="Disable Workflow"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <div className="w-full">
                    
                    <div className="my-7 text-ep-gray-600">
                        Are you sure you want to disable this workflow? <br /> You can always enable it again.
                    </div>
                    
                    <div className="w-full flex items-center justify-start pt-3">
                        <ButtonLoader loading={disabledWorkflowLoading} onClick={disableWorkflow} type="button" className="btn bg-[#dc2626] text-white w-full mr-3">
                            Yes
                        </ButtonLoader>
                        
                        <button onClick={() => setIsOpen(false)} className="btn btn-transparent-primary w-full font-semibold">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </FormDrawer>
    )
}

export default DisableWorkflow;